// Navigation.styled.ts
import styled from "styled-components";

import { Span } from "utils/styling/typography.styled";

export const NavigationContainer = styled.nav`
    margin-top: 2rem; /* Tailwind class: mt-8 */
    padding-top: 2rem; /* Tailwind class: pt-8 */
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem; /* Tailwind class: gap-8 */
    border-top: 1px solid #e5e7eb; /* Tailwind class: border-t border-gray-200 */

    &.dark {
        border-color: #4a5568; /* Tailwind class: dark:border-gray-700 */
    }
`;

export const NavSection = styled.div`
    &.previous {
        text-align: left;
    }

    &.next {
        grid-column-start: 2;
        text-align: right;
    }
`;

export const NavHeading = styled.p`
    margin-bottom: 0.5rem; /* Tailwind class: mb-2 */
    text-transform: uppercase;
    letter-spacing: 0.05em; /* Tailwind class: tracking-wider */
    font-size: 0.875rem; /* Tailwind class: text-sm */
    color: #6b7280; /* Tailwind class: text-gray-500 */

    &.dark {
        color: #9ca3af; /* Tailwind class: dark:text-gray-400 */
    }
`;

export const NavLink = styled(Span)`
    font-weight: bold;
    color: inherit;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;
